import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class TemporarySearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from_date: null,
      to_date: null,
      email: "",
      regist_type: "",
      mail_auth: "",
      tel: "",
      sms_auth_status: "",
      page: 1,
    };
    this.handleChangeDateCreated = this.handleChangeDateCreated.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSearchData = this.handleSearchData.bind(this);
    this.resetInputField = this.resetInputField.bind(this);
  }

  /**
   * Call search data by text
   */
  handleSearchData() {
    const searchForm = {
      from_date: this.state.from_date
        ? this.state.from_date.format("YYYY-MM-DD")
        : "",
      to_date: this.state.to_date
        ? this.state.to_date.format("YYYY-MM-DD")
        : "",
      email: this.state.email,
      regist_type: this.state.regist_type,
      mail_auth: this.state.mail_auth,
      tel: this.state.tel,
      sms_auth_status: this.state.sms_auth_status,
      page: 1,
    };
    if (typeof this.props.onSearch === "function") {
      this.props.onSearch(searchForm);
    }
  }

  /**
   * Process change date create at
   */
  handleChangeDateCreated(date, dateType) {
    if (dateType == "from") {
      this.setState({
        from_date: date,
      });
    } else {
      this.setState({
        to_date: date,
      });
    }
  }

  /**
   * Process field change
   */
  handleFieldChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * Clear data input field
   */
  resetInputField() {
    this.setState({
      email: "",
      from_date: null,
      to_date: null,
      regist_type: "",
      mail_auth: "",
      tel: "",
      sms_auth_status: "",
    });
  }

  render() {
    return (
      <div className="collapse multi-collapse" id="search_client">
        <div className="card mt-3">
          <div className="card-header">仮登録者を検索する条件</div>
          <div className="card-body">
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    登録日（開始）
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD"
                      selected={this.state.from_date}
                      onChange={(e) => {
                        this.handleChangeDateCreated(e, "from");
                      }}
                      placeholderText="開始日"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    登録日（終了）
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD"
                      selected={this.state.to_date}
                      onChange={(e) => {
                        this.handleChangeDateCreated(e, "to");
                      }}
                      placeholderText="終了日"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    電話番号
                  </label>
                  <input
                    type="text"
                    onChange={this.handleFieldChange}
                    value={this.state.tel}
                    className="form-control"
                    name="tel"
                    placeholder="電話番号"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    メールアドレス
                  </label>
                  <input
                    type="text"
                    onChange={this.handleFieldChange}
                    value={this.state.email}
                    className="form-control"
                    name="email"
                    placeholder="メール"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                  <div className="form-group">
                      <label className="form-label" htmlFor="">種別</label>
                      <select className="form-control" name="regist_type" value={this.state.regist_type} onChange={this.handleFieldChange}>
                          <option value="">全て</option>
                          <option value="1">法人</option>
                          <option value="2">個人</option>
                      </select>
                  </div>
              </div>
              <div className="col-sm-3">
                  <div className="form-group">
                      <label className="form-label" htmlFor="">メール認証完了日時</label>
                      <select className="form-control" name="mail_auth" value={this.state.mail_auth} onChange={this.handleFieldChange}>
                          <option value="">全て</option>
                          <option value="1">未完了</option>
                          <option value="2">完了</option>
                      </select>
                  </div>
              </div>
              <div className="col-sm-3">
                  <div className="form-group">
                      <label className="form-label" htmlFor="">SMS認証ステータス</label>
                      <select className = "form-control"
                      name = "sms_auth_status"
                      value = {
                        this.state.sms_auth_status
                      }
                      onChange = {
                        this.handleFieldChange
                      } >
                          <option value="">全て</option>
                          <option value="1">認証済</option>
                          <option value="0">未認証</option>
                      </select>
                  </div>
              </div>
            </div>
          </div>
          <div className="card-footer text-center">
            <button
              type="reset"
              onClick={this.resetInputField}
              className="btn btn-light"
            >
              リセット
            </button>
            <button
              onClick={this.handleSearchData}
              type="submit"
              className="btn btn-secondary"
            >
              検索する
            </button>
          </div>
        </div>
      </div>
    );
  }
}
